

























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzsxCatalogDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private questions: any;
  @Prop()
  private current: any;
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 选择
   */
  private change(index) {
    this.$emit("change", index);
    this.$emit("update:ifVisible", false);
  }
}
